<template>
    <div class="RespiteEditor">
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="Fields"
                              :data="Respites"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable">
                        <template slot="EditRecord" scope="props">
                            <div class="EditRecord">
                                <span v-if="EditMode && CanEdit" class="underline pointer" @click="ShowEditRecord(props.rowData)">{{ formatDate(props.rowData.StartDate,'MM/DD/YY') }}</span>
                                <span v-else>{{ formatDate(props.rowData.StartDate,'MM/DD/YY') }}</span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddRecord()" class="pointer olive-green-text" />
                    </div>
                </b-col>
            </b-row>
        </b-container>
        


        <!--ADD RECORD MODAL-->
        <b-modal ref="add-modal" title="Record New Respite" hide-footer>
            <b-container>
                <b-form @submit="AddRecord">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Family Hosting the Child:</label>
                                <select class="form-control" v-model="NewRecord.HostResourceFamilyID" required>
                                    <option v-for="option in FosterResourceFamilyOptions" v-bind:value="option.value">
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Date Respite Started:</label>
                                <flat-pickr v-model="NewRecord.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Date Respite Ended:</label>
                                <flat-pickr v-model="NewRecord.EndDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Respite Billed:</label>
                                <select v-model="NewRecord.IsBilled" class="form-control" required>
                                    <option value=""></option>
                                    <option :value="false">No</option>
                                    <option :value="true">Yes</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelAddRecord()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                RECORD RESPITE
                            </b-button>
                            <b-button v-if="NewRecord.Id" size="md" variant="danger" type="button" @click="DeleteRecord(NewRecord.Id)">
                                DELETE RESPITE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        props: [
            'ClientSubProgramMembershipId',
            'HostResourceFamilyId',
            'UsingResourceFamilyId',
            'EditMode',
            'CanEdit'
        ],
        data: function () {
            return {
                Respites: [],

                FosterResourceFamilyOptions: [],
                NewRecord: {
                    HostResourceFamilyID: "",
                    StartDate: "",
                    EndDate: "",
                    IsBilled: false
                },
                TargetRecordID: "",
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
            }
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            boolYesNo(value) {
                if (value) {
                    return "Yes";
                } else {
                    return "No";
                }
            },
            GetRespites(showLoad = false) {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FosterRespites", { ClientSubProgramMembershipID: this.ClientSubProgramMembershipId, HostResourceFamilyId: this.HostResourceFamilyId, UsingResourceFamilyId: this.UsingResourceFamilyId }, this.GetRespitesSuccess, () => { }, showLoad);
            },
            GetRespitesSuccess(response) {
                this.Respites = response.data.data;
            },
            GetAvailableFosterResourceFamilies() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/GetAvailablePlacements", { Id: this.ClientSubProgramMembershipId }, this.GetAvailableFosterResourceFamiliesSuccess, () => { }, false);
            },
            GetAvailableFosterResourceFamiliesSuccess(response) {
                this.FosterResourceFamilyOptions = response.data.data;
            },
            //ADD RECORD
            ShowAddRecord() {
                this.GetAvailableFosterResourceFamilies();
                this.NewRecord = {};
                this.$refs['add-modal'].show();
            },
            ShowEditRecord(rec) {
                this.GetAvailableFosterResourceFamilies();
                this.NewRecord = JSON.parse(JSON.stringify(rec));
                this.$refs['add-modal'].show();
            },
            CancelAddRecord() {
                this.$refs['add-modal'].hide();
            },
            AddRecord(e) {
                e.preventDefault();
                this.NewRecord.ClientSubProgramMembershipID = this.ClientSubProgramMembershipId;
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FosterRespites", this.NewRecord, this.AddRecordSuccess, () => { }, true);
            },
            AddRecordSuccess(response) {
                this.GetRespites(true);
                this.$refs['add-modal'].hide();
            },
            //DELETE RECORD
            DeleteRecord(id) {
                this.$MasterAPI.ExecuteRequest("DELETE", "Foster/FosterRespites/" + id, {}, this.DeleteRecordSuccess, () => { }, true);
            },
            DeleteRecordSuccess(response) {
                this.GetRespites(true);
                this.$refs['add-modal'].hide();
            }

        },
        components: {
            Vuetable,
            flatPickr
        },
        mounted() {
            this.GetRespites();
        },
        computed: {
            Fields: function () {
                if (this.ClientSubProgramMembershipId != null) {
                    return [
                        {
                            name: 'HostResourceFamily.Name',
                            title: "HOST FAMILY",
                        },
                        {
                            name: '__slot:EditRecord',
                            title: 'FROM'
                        },
                        {
                            name: 'EndDate',
                            title: "TO",
                            callback: 'formatDate|MM/DD/YY'
                        },
                        {
                            name: 'IsBilled',
                            title: "BILLED",
                            callback: 'boolYesNo'
                        },
                    ]
                } else if (this.HostResourceFamilyId != null) {
                    return [
                        {
                            name: 'ClientSubProgramMembership.Client.Person.FullName',
                            title: "CHILD",
                        },
                        {
                            name: 'UsingResourceFamily.Name',
                            title: "PLACEMENT FAMILY",
                        },
                        {
                            name: '__slot:EditRecord',
                            title: 'FROM'
                        },
                        {
                            name: 'EndDate',
                            title: "TO",
                            callback: 'formatDate|MM/DD/YY',
                        },
                        {
                            name: 'IsBilled',
                            title: "BILLED",
                            callback: 'boolYesNo',
                        },
                    ]
                } else if (this.UsingResourceFamilyId != null) {
                    return [
                        {
                            name: 'ClientSubProgramMembership.Client.Person.FullName',
                            title: "CHILD",
                        },
                        {
                            name: 'HostResourceFamily.Name',
                            title: "HOST FAMILY",
                        },
                        {
                            name: '__slot:EditRecord',
                            title: 'FROM'
                        },
                        {
                            name: 'EndDate',
                            title: "TO",
                            callback: 'formatDate|MM/DD/YY',
                        },
                        {
                            name: 'IsBilled',
                            title: "BILLED",
                            callback: 'boolYesNo',
                        },
                    ]
                } else {
                    return [];
                }
            }
        }
    }
</script>